import { Button, Icon, Spinner, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";

import { useChatForm } from "./use-chat-form";

export const ChatFormStopRecordingVoiceButton = () => {
  const { stopRecording, isProcessing, canEdit } = useChatForm();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button type="button" variant="secondary" size="xs" display="icon" onClick={stopRecording} disabled={!canEdit}>
          {isProcessing ? <Spinner className="size-3" /> : <Icon icon="stop" className="filled" />}
        </Button>
      </TooltipTrigger>
      <TooltipContent>Stop recording</TooltipContent>
    </Tooltip>
  );
};
